import React from "react";
import {Animation} from "../../feature/project/Shot";

export const AnimationItem = (props: { animation: Animation }) => {
    const [transform, setTransform] = React.useState(animationToTransformFrom(props.animation))
    const [opacity, setOpacity] = React.useState(props.animation.alphaFrom)

    return (
        <div
            onMouseEnter={() => {
                setTransform(animationToTransformTo(props.animation))
                setOpacity(props.animation.alphaTo)
            }}
            onMouseLeave={() => {
                setTransform(animationToTransformFrom(props.animation))
                setOpacity(props.animation.alphaFrom)
            }}>
            <img src={"/images/trans2.png"} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                filter: 'grayscale(100) opacity(0.3)',
                left: 0,
                top: 0,
            }}/>
            <img

                src={"/images/trans1.png"}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    opacity: opacity != undefined ? opacity : 1,
                    transitionProperty: 'transform, opacity',
                    transitionDuration: `${props.animation.duration}ms` || `0ms`,
                    transitionDelay: `${props.animation.startDelay}ms` || `0ms`,
                    transitionTimingFunction: `${props.animation.interpolator}` || `ease`,
                    transform: transform
                }}/>
            <div style={{
                position: 'absolute',
                background: '#ffffff',
                borderRadius: 18,
                padding: '4px 12px',
                bottom: 10,
                left: '50%',
                textWrap: 'nowrap',
                translate: '-50%'
            }}>
                {props.animation.title}
            </div>
        </div>
    )
}

export function animationToTransformTo(animation?: Animation, scale: number = 1): string {
    if (!animation) return ''
    return `${parse('translateX', animation?.translateToX != null ? (animation.translateToX / scale) : null, 'px')} ` +
        `${parse('translateY', animation.translateToY != null ? (animation.translateToY / scale) : null, 'px')} ` +
        `${parse('translateZ', animation.translateToZ, 'px')} ` +
        `${parse('scaleX', animation.scaleToX)} ` +
        `${parse('scaleY', animation.scaleToY)} ` +
        `${parse('scale', animation.scaleToZ)} ` +
        `${parse('rotateX', animation.rotateToX, 'deg')} ` +
        `${parse('rotateY', animation.rotateToY, 'deg')} ` +
        `${parse('rotateZ', animation.rotateToZ, 'deg')} `

}

export function animationToTransformFrom(animation?: Animation, scale: number = 1): string {
    if (!animation) return ''
    return `${parse('translateX', animation.translateFromX != null ? (animation.translateFromX / scale) : null, 'px')} ` +
        `${parse('translateY', animation.translateFromY != null ? (animation.translateFromY / scale) : null, 'px')} ` +
        `${parse('translateZ', animation.translateFromZ, 'px')} ` +
        `${parse('scaleX', animation.scaleFromX)} ` +
        `${parse('scaleY', animation.scaleFromY)} ` +
        `${parse('scale', animation.scaleFromZ)} ` +
        `${parse('rotateX', animation.rotateFromX, 'deg')} ` +
        `${parse('rotateY', animation.rotateFromY, 'deg')} ` +
        `${parse('rotateZ', animation.rotateFromZ, 'deg')} `

}

function parse(transform: string, value: number | undefined | null, unit: string = ''): string {
    return value !== undefined && value !== null ? `${transform}(${parseNumber(transform, value, unit)})` : ''
}

function parseNumber(transform: string, value: number | undefined, unit: string): string {
    return value !== undefined && value !== null ? ((((value > 0.0 && value < 1.0) || (value < 0.0 && value > -1.0)) && (transform.startsWith('translate'))) ? `${value * 1000}%` : `${value}${unit}`) : `0${unit}`
}